import React from 'react';
import { AlertTriangle } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { SectionCard, SectionFields, SectionFieldConfig, SectionFieldsProps, SectionTone } from './SectionCard';

interface MedicalNecessitySectionProps extends SectionFieldsProps {
  title: string;
  /** The plan's medical necessity fields (one justification, or several statement parts) */
  fields: SectionFieldConfig[];
  /** "Must include" checklist shown above the fields */
  guidance?: { heading: string; items: string[] };
  tone?: SectionTone;
  icon?: LucideIcon | null;
  collapsed?: boolean;
  onToggle?: () => void;
}

/** Phase 19 F25: medical necessity justification (PA and CMS-485), shared card for every plan. */
const MedicalNecessitySection: React.FC<MedicalNecessitySectionProps> = ({
  title, fields, guidance, tone = 'red', icon = AlertTriangle, collapsed = false, onToggle, ...fieldProps
}) => (
  <SectionCard title={title} icon={icon} tone={tone} collapsed={collapsed} onToggle={onToggle}>
    {guidance && (
      <div className="mb-3 p-3 bg-white border border-red-300 rounded">
        <p className="text-sm text-gray-700 mb-2"><strong>{guidance.heading}</strong></p>
        <ul className="text-xs text-gray-600 space-y-1 ml-4">
          {guidance.items.map(item => <li key={item}>• {item}</li>)}
        </ul>
      </div>
    )}
    <SectionFields fields={fields} columns={1} {...fieldProps} />
  </SectionCard>
);

export default MedicalNecessitySection;
